document.addEventListener("DOMContentLoaded", () => {
  const signupToggle = document.querySelector('#signup-toggle');
  const signupCancel = document.querySelector('#signup-cancel');
  const signupForm = document.querySelector('#signup-form');
  const refreshCaptcha = document.querySelector('#refresh-captcha');
  const form = document.querySelector('#signupForm');
  const errorForm = document.querySelector('#error-form');
  const signupOverlay = document.querySelector('.signup-overlay');
  const replaceMessage = document.querySelector('#replace-mail');
  const successForm = document.querySelector('#success-form');
  const captchaImages = document.querySelectorAll('.signup-captcha');
  const captchaTexts = document.querySelectorAll('.captchaText');
  const keys = document.querySelectorAll('.key');


  const createAccountBtn = document.querySelector('.step a[href="#step-1"]');

  if (createAccountBtn) {
    createAccountBtn.removeAttribute('href');
    createAccountBtn.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector('#step-1').scrollIntoView();
      toggleSignupForm(true);
    });
  }

  const toggleSignupForm = (show) => {
    signupToggle.style.display = show ? 'none' : 'inline-block';
    signupForm.classList.toggle('hide-signup', !show);
    signupForm.classList.toggle('show-signup', show);
  };

  signupCancel.addEventListener('click', (e) => {
    e.preventDefault();
    toggleSignupForm(false);
  });

  if (signupToggle) {
    signupToggle.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('click')
      toggleSignupForm(true);
    });
  }

  form.addEventListener('input', () => {
    errorForm.style.display = 'none';
  });

  form.addEventListener('submit', event => {
    event.preventDefault();

    signupOverlay.style.display = "block";

    if (!form.checkValidity()) {
      event.stopPropagation();
      document.querySelector('#signup-btn').style.display = "block";
      setTimeout(() => {
        signupOverlay.style.display = "none";
      }, 500)
    } else {
      const data = new FormData(form);

      const signupData = {
        accountInfo: {
          isp: data.get('isp'),
          firstName: data.get('firstName'),
          lastName: data.get('lastName'),
          companyName: data.get('companyName'),
          emailAddress: data.get('emailAddress'),
        },
        captcha: {
          captchaInput: data.get('captchaInput'),
          captchaText: data.get('captchaText'),
          key: data.get('key')
        }
      };



      fetch('/app/service/signup/create-account', {
        method: 'POST',
        body: JSON.stringify(signupData)
      })
        .then((response) => response.json())
        .then(res => {
          if (res.status) {
            getCaptchaImage();
            errorForm.innerHTML = res.detail;
            errorForm.style.display = 'block';
          } else {
            form.style.display = 'none';
            replaceMessage.innerHTML = replaceMessage.innerHTML.replace(/aaaaa/g, res.emailAddress);
            successForm.style.display = 'block';
            form.reset();
          }
          setTimeout(() => {
            signupOverlay.style.display = "none";
          }, 500)
        });
    }
    form.classList.add('was-validated');
  });

  refreshCaptcha.addEventListener('click', (e) => {
    e.preventDefault();
    getCaptchaImage();
  });

  function getCaptchaImage() {
    fetch('/app/service/signup/captcha')
      .then((response) => response.json())
      .then((data) => {
        captchaImages.forEach((captchaImage) => {
          captchaImage.setAttribute('src', data.imageData);
        });
        captchaTexts.forEach((captchaText) => {
          captchaText.value = data.captchaText;
        })
        keys.forEach((key) => {
          key.value = data.key;
        })
      });
  }

  getCaptchaImage();
});
